module.exports = __webpack_public_path__ + "static/CODE-6f169673d0b62c0fa8aff4cca00ad17f.png";